import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/LayoutView.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/DashboardHome.vue')
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import('@/components/NotificationsList.vue')
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/components/SettingsList.vue')
      },
      // {
      //   path: 'wallet/recharge',
      //   name: 'wallet-recharge',
      //   component: () => import('@/components/forms/FormWalletRecharge.vue')
      // },
      {
        path: 'invoice/add',
        name: 'newInvoce',
        // component: () => import('@/components/forms/FormInvoices.vue')
        component: () => import('@/views/invoices/searchTPagaProvider.vue')
      },
      {
        path: 'invoice/edit/:id',
        name: 'editInvoice',
        // component: () => import('@/components/forms/FormInvoices.vue')
        component: () => import('@/views/invoices/EditInvoice.vue')
      },

      {
        path: 'invoice/:id',
        name: 'invoiceDetail',
        component: () => import('@/views/invoices/DetailsView.vue')
      },
      {
        path: 'invoices',
        name: 'listInvoices',
        component: () => import('@/views/invoices/ListView.vue')
      },
      {
        path: 'pay-invoice/:id',
        name: 'payInvoice',
        component: () => import('@/views/invoices/PayInvoice.vue')
      },
      {
        path: 'pay-invoices',
        name: 'payInvoices',
        component: () => import('@/components/others/PayInvoices.vue')
      },
      {
        path: 'payment-wallet/invoice/:id',
        name: 'invoiceWallet',
        component: () => import('@/components/others/PayInvoiceWallet.vue')
      },
      {
        path: 'payment-wallet/invoices',
        name: 'invoicesWallet',
        component: () => import('@/components/others/PayInvoicesWallet.vue')
      },
      {
        path: 'transaction/:collection/:documentId/:id',
        name: 'transactionDetail',
        component: () => import('@/views/transactions/DetailsView.vue')
      },
      //Bank account
      {
        path: 'bank-accounts',
        name: 'bankAccounts',
        component: () => import('@/components/others/BankAccounts.vue')
      },
      {
        path: 'bank-accounts/add',
        name: 'newBankAccount',
        component: () => import('@/components/forms/FormBankAccount.vue')
      },
      {
        path: 'bank-accounts/add/nequi',
        name: 'newNequiAccount',
        component: () => import('@/components/forms/FormNequiLinking.vue')
      },
      {
        path: 'bank-accounts/add/nequi/:id',
        name: 'nequiAccountConfirmation',
        component: () => import('@/components/others/NequiLinkingConfirmation.vue')
      },
      {
        path: 'transactions',
        name: 'transactions',
        children: [
          {
            path: 'all',
            name: 'all',
            component: () => import('@/views/transactions/ListView.vue')
          },
          {
            path: 'status',
            name: 'status',
            component: () => import('@/components/others/TransactionsStatus.vue')
          },
          {
            path: 'pse',
            name: 'pse',
            component: () => import('@/components/others/TransactionsPSE.vue')
          },
          {
            path: 'bank',
            name: 'bank',
            component: () => import('@/components/others/TransactionsBank.vue')
          },
          {
            path: 'nequi',
            name: 'nequi',
            component: () => import('@/components/others/TransactionsNequi.vue')
          },
          {
            path: 'account-linked',
            name: 'account-linked',
            component: () => import('@/components/others/TransactionAccountLinked.vue')
          },
          {
            path: 'payment-status',
            name: 'payment-status',
            component: () => import('@/components/others/PaymentResult.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/views/auth/SignIn.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/SignIn.vue'),
    async beforeEnter(to, from, next) {
      const { checkAuth } = useAuthStore()
      const isAuthenticated = await checkAuth()
      isAuthenticated ? next({ name: 'dashboard' }) : next()
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/SignUp.vue')
  },
  {
    path: '/invoice/add',
    name: 'addInvoice',
    component: () => import('@/components/forms/FormInvoices.vue')
  },
  {
    path: '/intro',
    name: 'intro',
    component: () => import('@/components/IntroUser.vue')
  },
  {
    path: '/invoice/reference/:providerId',
    name: 'invoiceReference',
    component: () => import('@/components/others/InvoiceReference.vue'),
    props: true
  },
  {
    path: '/invoice/customize/:providerId/:placeholder',
    name: 'registerTemporary',
    component: () => import('@/views/invoices/CustomizeInvoiceTemporary.vue'),
    props: true
  },
  {
    path: '/invoice/tpaga/:providerId/:reference',
    name: 'tpagaInvoiceDetail',
    component: () => import('@/views/invoices/TpagaInvoiceDetail.vue'),
    props: true
  },
  {
    path: '/invoice/customize/:providerId/:invoiceId/',
    name: 'customizeInvoice',
    component: () => import('@/views/invoices/CustomizeInvoice.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/invoice/customize/:providerId/:invoiceId/:amount',
    name: 'customizeInvoice',
    component: () => import('@/views/invoices/CustomizeInvoice.vue'),
    props: true,
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const { checkAuth } = useAuthStore()
  const isAuthenticated = await checkAuth()
  if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated) {
    next({ name: 'onboarding' })
  } else {
    next()
  }
})

export default router
